import {useEffect, useState} from 'react';
import {usePage} from '@inertiajs/react';

// Hook for "Student Email Verified" Edit
export const useStudentEmailVerifiedAlert = () => {
  const {props} = usePage(); // Access Inertia page props
  const {auth} = props;
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (
      (auth?.user?.email.endsWith('.edu') ||
        auth?.user?.email.endsWith('mail.utoronto.ca')) &&
      !auth?.hasAccess &&
      auth?.user?.email_verified_at
    ) {
      setVisible(true);
    }
  }, [auth]);

  return [visible, setVisible];
};

// Hook for "Student Email Not Verified" Edit
export const useStudentEmailNotVerifiedAlert = () => {
  const {props} = usePage();
  const {auth} = props;
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (
      (auth?.user?.email.endsWith('.edu') ||
        auth?.user?.email.endsWith('mail.utoronto.ca')) &&
      !auth?.hasAccess &&
      !auth?.user?.email_verified_at
    ) {
      setVisible(true);
    }
  }, [auth]);

  return [visible, setVisible];
};
